/**
 * PWA工具函数
 * 提供清除缓存和强制更新的功能
 */

/**
 * 清除所有PWA缓存
 * 可以在需要强制更新时调用
 */
export async function clearPWACache(): Promise<boolean> {
  try {
    // 1. 获取所有缓存名称
    const cacheNames = await caches.keys();
    console.log('找到以下缓存:', cacheNames);
    
    // 2. 删除所有缓存
    await Promise.all(
      cacheNames.map(cacheName => {
        console.log(`正在删除缓存: ${cacheName}`);
        return caches.delete(cacheName);
      })
    );
    
    console.log('所有PWA缓存已清除');
    return true;
  } catch (error) {
    console.error('清除PWA缓存失败:', error);
    return false;
  }
}

/**
 * 强制更新PWA
 * 清除缓存并重新加载页面
 */
export async function forceUpdatePWA(): Promise<void> {
  try {
    // 1. 清除所有缓存
    const cleared = await clearPWACache();
    
    // 2. 注销所有Service Worker
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      
      for (const registration of registrations) {
        console.log('注销Service Worker:', registration);
        await registration.unregister();
      }
      
      console.log('所有Service Worker已注销');
    }
    
    // 3. 重新加载页面
    if (cleared) {
      console.log('正在重新加载页面以应用更新...');
      window.location.reload();
    }
  } catch (error) {
    console.error('强制更新PWA失败:', error);
    alert('更新失败，请尝试手动刷新页面');
  }
}

/**
 * 检查PWA更新
 * 手动触发Service Worker更新检查
 */
export async function checkForPWAUpdate(): Promise<void> {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        console.log('正在检查PWA更新...');
        await registration.update();
        console.log('PWA更新检查完成');
      } else {
        console.log('未找到已注册的Service Worker');
      }
    } catch (error) {
      console.error('检查PWA更新失败:', error);
    }
  }
}
